
























































import Vue from 'vue';
import { mapState } from 'vuex';
import { pick } from 'lodash';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    TopNav,
  },
  computed: {
    ...mapState('setting', ['currencies']),
  },
  data() {
    return {
      logo: '/assets/images/integrations/pay-pal@3x.png',
      paymentInfo: null,
      selectedCurrency: null,
      isLoading: true,
      inProgress: false,
    };
  },
  methods: {
    async update() {
      this.inProgress = true;
      const data = pick(this.paymentInfo, [
        'paypal_email',
        'paypal_pdt',
        'paypal_pdt_token',
        'currency',
      ]);
      data.payment_gateway = 'paypal';
      try {
        this.paymentInfo = await this.$store.dispatch(
          'setting/updatePaymentInfo',
          data
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('SETTINGS.NOTIFICATIONS.PAYPAL_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    selectCurrency(currency) {
      this.selectedCurrency = currency;
      this.paymentInfo.currency = currency?.code;
    },
  },
  async mounted() {
    const [paymentInfo, currencies] = await Promise.all([
      this.$store.dispatch('setting/getPaymentInfo'),
      this.$store.dispatch('setting/getCurrencies', 'paypal'),
    ]);
    this.paymentInfo = paymentInfo;

    this.selectedCurrency = this.currencies.find(
      ({ code }) => code === this.paymentInfo.currency
    );

    this.isLoading = false;
  },
});
